import React, { useEffect } from 'react';
import '../styles/ValidationNotification.css';

interface ValidationNotificationProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}

const ValidationNotification: React.FC<ValidationNotificationProps> = ({ 
  message, 
  isVisible, 
  onClose 
}) => {
  useEffect(() => {
    if (isVisible) {
      // Automatically hide the notification after 5 seconds
      const timeout = setTimeout(() => {
        onClose();
      }, 5000);
      
      // Clean up the timeout when the component unmounts or when isVisible changes
      return () => clearTimeout(timeout);
    }
  }, [isVisible, onClose]);

  return (
    <div className={`validation-notification ${isVisible ? 'visible' : ''}`}>
      {message}
    </div>
  );
};

export default ValidationNotification; 